var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWebUrlIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero",
  stroke: "none"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  x: 0,
  y: 0
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M3.5 21.5c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 1.5 19.5v-15c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 3.5 2.5h17c.55 0 1.02.196 1.413.587.391.392.587.863.587 1.413v15c0 .55-.196 1.02-.587 1.413a1.926 1.926 0 0 1-1.413.587h-17Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  d: "M3.5 19.5h17v-12h-17v12ZM4.5 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM8 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm3.5 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "m9.596 11.026-2.47 2.47L9.6 15.973l-1.061 1.06-2.474-2.475L5 13.5l3.536-3.535 1.06 1.06Zm4.809 0 2.47 2.47-2.474 2.476 1.061 1.06 2.474-2.475 1.065-1.057-3.535-3.535-1.061 1.06ZM12.389 8.85l1.455.364-2.234 8.934-1.455-.363 2.234-8.935Z"
}))));
export default SvgWebUrlIcon;